import { useAppEnvironmentStore } from '../../stores/AppEnvironment/appEnvironment.store';
import { Brand } from '../context/ApplicationContext/applicationContext.types';
import { Ability } from '../users/ability.types';
import { UserRole } from '../users/roles';
import { OrderActions } from './actions/OrderActions';
import { GetActionsParams } from './actions/types/actions.types';
import { getLastOrderGatewayPayment } from './actions/utils/orderSummaryAction.utils';
import { OrderStatus } from './interfaces/order-status.interface';
import {
  ListOrdersDTO,
  OrderListType,
  OrderListWithBaseItem,
  OrderWithActions,
} from './order.types';

interface FormatOrdersParams {
  orders: ListOrdersDTO[];
  hasIntegrations: boolean;
  isSystemParamsResetIntegration?: boolean;
  isEnableShareSuggestedOrder?: boolean;
  triggerIntegrationConfig?: OrderStatus;
  role: UserRole;
  brand?: Brand;
  hasOrderIntegration: boolean;
  ability: Ability;
  refundLimitHours: number;
  requirePaymentReleaseForImmediate: boolean;
  requirePaymentReleaseForPreOrder: boolean;
}

export const formatOrders = ({
  orders,
  hasIntegrations,
  isSystemParamsResetIntegration,
  isEnableShareSuggestedOrder,
  triggerIntegrationConfig,
  role,
  brand,
  hasOrderIntegration,
  ability,
  refundLimitHours,
  requirePaymentReleaseForImmediate,
  requirePaymentReleaseForPreOrder,
}: FormatOrdersParams): OrderWithActions[] =>
  orders?.map((order) => {
    const lastGatewayPayment = getLastOrderGatewayPayment(order.orderGatewayPayments);
    const { appEnvironment } = useAppEnvironmentStore.getState();

    const orderListActionsParams: GetActionsParams = {
      hasSplit: !!order.splitSettings?.length,
      splitted: order.splitted,
      status: order.status,
      archivedOrder: order.archived,
      isSystemParamsResetIntegration,
      isEnableShareSuggestedOrder,
      orderPaymentStatus: order.paymentStatus,
      hasIntegrations,
      synchronized: order.synchronized,
      triggerIntegrationConfig,
      brand,
      role,
      hasOrderIntegration,
      userAbility: ability,
      orderType: order.type,
      lastGatewayPaymentStatus: lastGatewayPayment?.status,
      lastGatewayPaymentUpdatedAt: lastGatewayPayment?.updatedAt,
      refundLimitHours,
      requirePaymentGateway: order.orderConditions?.some(
        (condition) => condition.paymentRequirePaymentGateway,
      ),
      requirePaymentReleaseForImmediate,
      requirePaymentReleaseForPreOrder,
      appEnvironment,
    };

    const orderActions = new OrderActions();
    const actions = orderActions.getActions(orderListActionsParams);

    return {
      ...order,
      orderActions: actions || [],
    };
  });

export const formatOrdersWithChildren = (orders: OrderListType[]): OrderListWithBaseItem[] =>
  orders.reduce((acc, order) => {
    if (order.isParent) {
      const children: OrderListWithBaseItem[] = (order.subRows || []).map((subRow) => {
        return {
          ...subRow,
          parentId: order.baseCode,
          id: subRow.orderId,
          subRows: [],
          isParent: false,
        };
      });

      const result: OrderListWithBaseItem[] = [
        ...acc,
        { ...order, id: order.baseCode, subRows: [] },
        ...children,
      ];
      return result;
    }

    return [...acc, { ...order, parentId: undefined, id: order.orderId }];
  }, [] as OrderListWithBaseItem[]);
